module.exports = __webpack_public_path__ + "img/short01-57s-preview.ed5ccc1e.jpg";